import { pubsub } from './pubsub';

// renders the project info sent from localStorage
export function processLocalStorage() {
	pubsub.subscribe('projectsStored', renderProjects);
}

export function renderProjects(localStorageList) {
	//const projectSection = document.querySelector('.project-section');
	const fragment = new DocumentFragment();
	for (let i = 0; i < localStorageList.length; i++) {
		const projectContainer = document.createElement('div');
		projectContainer.classList.add('project-container', 'menu-item');
		const projectButton = document.createElement('a');
		projectButton.classList.add('project-button');
		projectButton.href = '#';
		projectButton.innerText = localStorageList[i].name;
		projectButton.setAttribute('data-index', localStorageList[i].projectId);
		projectButton.setAttribute('data-name', localStorageList[i].name);
		projectContainer.appendChild(projectButton);

		// delete button
		const projectDeleteContainer = document.createElement('button');
		projectDeleteContainer.setAttribute('data-index', localStorageList[i].projectId);
		projectDeleteContainer.classList.add('project-delete-button');
		renderDeleteIcon(projectDeleteContainer);
		projectContainer.appendChild(projectDeleteContainer);

		// click event to select the project and display it in the content area
		projectButton.addEventListener('click', displaySelectedProject);

		// appending the prjectContainer to the fragment
		fragment.appendChild(projectContainer);
	}
	pubsub.publish('projectsRendered', fragment);
}

function renderDeleteIcon(node) {
	const fragment = new DocumentFragment();
	// creating the svg element
	const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
	// setting svg attributes
	iconSvg.setAttribute('fill', 'black');
	iconSvg.setAttribute('viewBox', '0 0 24 24');
	iconPath.setAttribute('d', 'M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z');
	// adding css class
	iconSvg.classList.add('project-delete-icon');
	// appending nodes
	iconSvg.appendChild(iconPath);
	fragment.appendChild(iconSvg);
	return node.appendChild(fragment);
}

export function deleteProject() {
	document.querySelector('body').addEventListener('click', (event) => {
		if (event.target.classList.contains('project-delete-button')) {
			const projectIndex = event.target.dataset.index;
			pubsub.publish('projectDeleted', projectIndex);
		};
	});
}

// publishes the project info
// when a project is clicked in order
// for its tasks to be displayed
function displaySelectedProject(event) {
	const projectInfo = {
		name: event.target.dataset.name,
		index: event.target.dataset.index
	};
	pubsub.publish('projectSelected', projectInfo);
}
